export default __webpack_public_path__ + "static/media/new-filter-box.d23eb4b4.jpg";